/**
 * @desc 发布模型
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(
  params: API.activiti.activiti.deploy.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activiti/deploy`, {
      method: "PUT",
      params,

      ...options,
    }),
  );
}
